import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Typography, Box, Button, Alert } from "@mui/material";
import { Routes, Route, useNavigate } from "react-router-dom";
import Home from "./Home";
import Settings from "./Settings";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import HistoricoAltas from "../components/HistoricoAltas";

const drawerWidth = 240;

const Dashboard = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [showHistorico, setShowHistorico] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Obtener el rol desde localStorage
    const role = localStorage.getItem("role");
    setUserRole(role);
  }, []);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsMobile(true);
        setIsOpen(false);
      } else {
        setIsMobile(false);
        setIsOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflowX = "hidden";
    return () => {
      document.body.style.overflowX = "auto";
    };
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <Nav isOpen={isOpen} toggleSidebar={toggleSidebar} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          ml: isOpen ? `${drawerWidth}px` : 0,
          transition: "margin-left 0.3s ease-in-out",
          width: isOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
          overflowX: "hidden",
        }}
      >
        <AppBar
          position="static"
          sx={{ backgroundColor: "#ededed", color: "#6e6e6e", marginBottom: "35px" }}
        >
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Informática
            </Typography>
          </Toolbar>
        </AppBar>

        {/* Si el usuario NO es admin, mostrar mensaje de error */}
        {userRole !== "admin" ? (
          <Alert severity="error" sx={{ margin: "20px", textAlign: "center" }}>
            Acceso denegado. No tienes permisos para ver esta sección.
          </Alert>
        ) : (
          <>
            {/* Botón para mostrar el componente HistoricoAltas */}
            <Button
              variant="contained"
              color="primary"
              onClick={() => setShowHistorico(!showHistorico)}
              sx={{ marginBottom: 2 }}
            >
              {showHistorico ? "Ocultar Histórico de Altas" : "Mostrar Histórico de Altas"}
            </Button>

            {showHistorico && <HistoricoAltas />}
          </>
        )}

        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  );
};

export default Dashboard;
